import React from 'react';

export const CardPartner = (props) => {
  const {title, image, classes, link, query, data} = props;
  const {socials, text, token} = data.acf;

  const Tag = (link) ? 'a' : 'div';
  const attributes = {};
  if (link) {
    attributes.href = link;
    attributes.target = '_blank';
    attributes.rel = 'noopener';
  }
  const getTitle = () => {
    if (!query) return title;
    return title.replace(new RegExp(query, "gi"), (match) => `<mark>${match}</mark>`);
  }
  return (
    <div className={'position-relative'}>
      <Tag
        {...attributes}
        className={`zg-card-partner d-block bg-black p-4 border rounded-4 pb-18 h-100 ${classes || ''}`}>

        <img className="mb-5 me-2 me-auto d-block" src={image || '/rsk-icon.png'} alt={title} width="123" height="52"/>
        <h3 className="h6 mb-3 letter-spacing-1" dangerouslySetInnerHTML={{__html:getTitle()}}></h3>
        {text && (
          <div className={'zg-text-block'} dangerouslySetInnerHTML={{__html: text}}></div>
        )}
      </Tag>
      <div className='mt-0'>

      <div className="position-absolute end-0 bottom-0 z-1 p-4">
      <div className="d-flex justify-content-end">
      {token && (
          <p className={'mt-5 pb-0'} dangerouslySetInnerHTML={{__html:token
          }}></p>
        )}
      </div>
      <div className='d-flex justify-content-end '>
      {socials?.twitter && (
          <a href={socials?.twitter} className={'p-2 zg-social-icon'} target={'_blank'} rel={'noopener'}>
            <svg width={21} height={21}>
              <use xlinkHref="#icon-x-solid"></use>
            </svg>
          </a>

        )}
        {socials?.github && (
          <a href={socials?.github} className={'p-2 zg-social-icon'} target={'_blank'} rel={'noopener'}>
            <svg width={21} height={21}>
              <use xlinkHref="#icon-github-solid"></use>
            </svg>
          </a>

        )}
        {socials?.discord && (
          <a href={socials?.discord} className={'p-2 zg-social-icon'} target={'_blank'} rel={'noopener'}>
            <svg width={21} height={21}>
              <use xlinkHref="#icon-discord-solid"></use>
            </svg>
          </a>
        )}
      </div>
      </div>
      </div>

    </div>
  )
}
